export default{
    mounted(el, binding)
    {
        const allowedCountries = binding.value || [];

        // Accès au composant via binding.instance
        const component = binding.instance;

        if(!component || !component.$store)
        {
            console.warn('v-unless-country : no store access.');
            return;
        }

        const userCountry = component.$store.state.account.cEntity?.country;

        if(allowedCountries.includes(userCountry))
        {
            el.remove();
        }
    },
};
